import React from 'react';
import { NavigationButtons } from './NavigationButtons';

interface FormStepLayoutProps {
  children: React.ReactNode;
  activeStep: number;
  totalSteps: number;
  onNext: () => void;
  onPrevious: () => void;
  onSubmit: () => void;
  isValid?: boolean;
  isFormComplete?: boolean;
  isCoverPage?: boolean;
}

export function FormStepLayout({
  children,
  activeStep,
  totalSteps,
  onNext,
  onPrevious,
  onSubmit,
  isValid = true,
  isFormComplete = false,
  isCoverPage = false
}: FormStepLayoutProps) {
  // Fundo branco opaco + texto preto. Antes era bg-background/10 (10% alpha)
  // sobre imagem de fundo escura -> texto ilegivel.
  //
  // Os componentes de campo (labels, placeholders, bordas, checkbox) usam as
  // utilidades Tailwind *-background, que resolvem para --background = BRANCO.
  // Como classe explicita ganha da cor herdada, o `color` acima nao os alcanca
  // e eles ficam brancos sobre este card branco. Em vez de trocar a classe em
  // cada campo -- o CSS compilado nem tem `border-b-foreground` nem as variantes
  // de opacidade -- redefinimos o token so dentro do card: text-background,
  // border-b-background, placeholder:text-background/60 e bg-background/10
  // passam todos a resolver para a cor escura, de forma consistente, e qualquer
  // campo novo ja nasce correto. A sidebar fica fora do card e nao e afetada
  // (la o branco esta certo, sobre a foto escura de fundo).
  return (
    <div
      className="flex overflow-y-auto gap-4 sm:gap-8 z-0 grow flex-col p-3 sm:p-5 sm:px-8 sm:py-6 rounded-xl shadow-lg w-full sm:max-w-[700px] sm:flex-1"
      style={{
        backgroundColor: 'rgba(255, 255, 255, 0.97)',
        color: '#111827',
        '--background': '222.2 47.4% 11.2%',
      } as React.CSSProperties}
    >
      <div className="flex flex-col min-h-full">
        <div className="flex-1">
          {children}
        </div>
        <NavigationButtons
          activeStep={activeStep}
          totalSteps={totalSteps}
          onNext={onNext}
          onPrevious={onPrevious}
          onSubmit={onSubmit}
          isValid={isValid}
          isFormComplete={isFormComplete}
          isCoverPage={isCoverPage}
        />
      </div>
    </div>
  );
} 